'use client';
import style from './searchPart.module.scss';
import { useState } from "react";
import Input from "../../../common/form-elements/input/Input";
import SearchIcon from '../../../common/svg/SearchIcon';
import { InputTypes } from '../../../common/form-elements/input/Input.dto';

interface Props {

}
const SearchPart = ({}: Props) => {
    const [search, setSearch] = useState<string>('');
    const onKeyHandleSearch = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if(event.key == 'enter'){
            onSearch(search);
        }
    }
    const onIconClick = () => {
        onSearch(search);
    }
    const onSearch = async (search: string) => {
        // search sitemap-a ili cega god
    }
  return (
    <div className={style.searchWrapper}>
        <SearchIcon width={20} height={20} handleClick={onIconClick} />
        <Input 
            type={InputTypes.TEXT}
            value={search}
            onInput={(e) => setSearch(e.currentTarget.value)}
            classes={[style.searchInput]}
            onKeyDown={onKeyHandleSearch}
        />
    </div>
  )
};

export default SearchPart;
